import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    cita_status: null,
    cita_form: {
        resultado: null,
        opciones: [],
        nueva_cita: null
    }
};
const mutations = {
    updateField,
    updateCita: (state, payload) => {
        var sizeCita = Object.keys(payload.cita).length;
        if (sizeCita > 0) {
            state.cita_status = payload.cita.cita_status;
            state.cita_form = payload.cita.cita_form;
        }
        if(!payload.tabs_status.cita){
            var forma_pago = payload.necesidad.forma_pago.opciones;
            state.cita_form.opciones = [...forma_pago];
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
